import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventService, ScApiService } from '@sc-ui';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppChatsService } from 'src/services/app-chats.service';
import { LocalizationService } from 'src/services/localization.service';
import { fadeIn } from 'src/transitions';

@Component({
  standalone: false,
  selector: 'app-candidate',
  templateUrl: './candidate.component.html',
  styleUrls: ['./candidate.component.scss'],
  animations: [
    fadeIn
  ]
})
export class CandidateComponent implements OnInit, OnDestroy {

  onDestroy = new Subject<any>();

  state = 'out';

  notifications: any = [];

  id: any;

  projectId: any;

  candidate: any;

  project: any;

  chatStarted = false;

  isLoading = false;

  constructor(private api: ScApiService,
    private events: EventService,
    private route: ActivatedRoute,
    public loc: LocalizationService,
    private chatbot: AppChatsService) { }

  ngOnInit() {

    this.route.params.subscribe(params => {

      console.log(params)
      this.onDestroy.next();
      this.id = params['id'];
      this.projectId = params['projectId'] ? parseInt(params['projectId']) : null;

      this.events
        .channel(`candidates/${this.id}`)
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => this.load());

      if (this.projectId)
      {
        this.events
          .channel(`projects/${this.projectId}/assignments`)
          .pipe(takeUntil(this.onDestroy))
          .subscribe((d: any) => {

            console.log(d);

            if (d.Payload?.CandidateId != this.candidate.Id)
              return;

            this.candidate.Assignment.AcceptanceStatus = d.Payload.AcceptanceStatus;
            this.candidate.Assignment.IsHired = d.Payload.IsHired;
          });
      }

      this.load();
    });
  }

  load() {

    if (!this.id) return;
    if (this.isLoading) return;

    this.isLoading = true;

    // reached without a project: the candidate comes from the company pool, so
    // there is no assignment, no project and no project notifications to show
    if (!this.projectId) {

      this.project = null;
      this.notifications = [];

      this.api.get(`candidates/${this.id}`).subscribe((d: any) => {
        this.candidate = d;
        this.isLoading = false;
        setTimeout(() => this.state = 'in', 100);
      });

      return;
    }

    var isLoadingProject = true;
    var isLoadingCandidate = true;

    this.api.get(`projects/${this.projectId}/candidates/${this.id}`).subscribe((d: any) => {
      this.candidate = d;

      isLoadingCandidate = false;
      if (!isLoadingProject) {
        this.isLoading = false;
      }

      setTimeout(() => this.state = 'in', 100);

    });

    this.api.get(`projects/${this.projectId}`).subscribe(d => {
      this.project = d;

      isLoadingProject = false;
      if (!isLoadingCandidate) {
        this.isLoading = false;
      }
    });

    this.api.get(`projects/${this.projectId}/candidates/${this.id}/notifications`).subscribe(d => {
      this.notifications = d;
    });
  }

  ngOnDestroy() {
    this.chatbot.cancelBotChat();
    this.onDestroy.next();
  }

  startChat(name) {
    this.chatbot.candidateChat(this.projectId, this.id, name);
  }

  execute(notification) {
    if (notification.Content == "#candidatedecide") {
      this.startChat('decide');
    }

    if (notification.Content == "#candidatefeedback") {
      this.startChat('feedback');
    }

    if (notification.Content == "#candidatestatus") {
      this.startChat('status');
    }
  }

}
